import {IRouletteBet} from "./IRouletteBet";

export class EvenOddBet implements IRouletteBet {
    constructor(public evenNumbers: boolean, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/EvenOddBet.ts